import styles from "../../styles/common/ModalFormViewButton.module.scss"
import {IcnChevronRight} from "../../assets/icons";

import clsx from "clsx";

import {cModalFormViewButton} from "../../utils";

import Button from "./Button";

function ModalFormViewButton(
  {
    icon,
    title,
    description,
    onClick,
    enabled,
  }: cModalFormViewButton) {
  return (
    <Button
      extraClassName={clsx(
      styles.cModalFormViewButton,
      "c-modal-form-view-button",
      !enabled && "is-disabled" // Add a disabled class when not enabled
      )}
      btnVariant="link"
      title={title}
      onClick={onClick}
      disabled={!enabled}
    >
      <i className="c-button-icon">
        {icon}
      </i>

      <span>
        <em>{title}</em>
        <span>{description}</span>
      </span>

      <i className="c-button-icon-chevron">
        <IcnChevronRight/>
      </i>
    </Button>
  );
}

export default ModalFormViewButton;